import { getNavigationType } from '../../utils/get-navigation-type.js';
export const buildViewListingEvent = (inputProperties) => ({
    ...inputProperties,
    object: Promise.resolve(inputProperties.object).then((objectProperties) => ({
        ...objectProperties,
        navigationType: getNavigationType(),
        type: 'Listing',
        url: window.location.href,
    })),
});
//# sourceMappingURL=event-builder.js.map